import React from 'react'
import T from 'prop-types'
import { Paper, Stack } from '@mui/material'

export default function CarCardAdditionalDetails({
  vertical,
  edit,
  sx,
  children,
  ...others
}) {
  return (
    <Paper
      variant="outlined"
      elevation={0}
      sx={{
        p: vertical ? 2 : 1,
        mt: vertical ? 2 : 1,
        borderColor: edit && !vertical ? 'text.primary' : undefined,
        ...sx,
      }}
      {...others}
    >
      <Stack direction={vertical ? undefined : 'row'}>{children}</Stack>
    </Paper>
  )
}

CarCardAdditionalDetails.propTypes = {
  edit: T.bool,
  sx: T.object,
  vertical: T.bool,
}
